import { forwardRef, MouseEvent, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components/macro';
import { ChipProps } from './chip.types';
import { IconWrapper, StyledChip } from './chip.styled';
import { Icons } from 'assets';
import { SVG } from '../../svg/svg';
import { Text } from '../text';

/**
 * Универсальный Chip компонент дизайн-системы.
 */
export const Chip = observer(
  forwardRef<HTMLDivElement, ChipProps>(
    ({ label, value, size = 's', disabled, onRemove, ...restProps }, ref) => {
      const theme = useTheme();

      const [visible, setVisible] = useState<boolean>(true);
      const [isClosing, setIsClosing] = useState<boolean>(false);

      if (!visible) {
        return null;
      }

      const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
        if (!disabled && value) {
          e.stopPropagation();

          setIsClosing(true);

          setTimeout(() => {
            onRemove?.(value);
            setVisible(false);
          }, 300);
        }
      };

      return (
        <StyledChip
          ref={ref}
          {...restProps}
          $size={size}
          $isClosing={isClosing}
          aria-disabled={disabled}
          role="button"
          tabIndex={disabled ? -1 : 0}
        >
          <Text variant={size === 'm' ? 'button-14' : 'button-12'} truncate>
            {label}
          </Text>

          {onRemove && (
            <IconWrapper aria-hidden="true" onClick={handleRemove}>
              <SVG
                src={Icons.Cross}
                props={{
                  cursor: 'pointer',
                  color: theme.semantic.icon.secondary,
                }}
              />
            </IconWrapper>
          )}
        </StyledChip>
      );
    }
  )
);
